export default __webpack_public_path__ + "static/media/summary-active.565976de.svg";